export default [
  [`Размеры`, `3XL`, `4XL`, `5XL`],
  [`Российский размер`, `54-56`, `56-58`, `58-60`],
  [`Грудь`, `64`, `67`, `70`],
  [`Длина`, `80`, `82`, `84`]
];
